import '../../css/base.css';

const Location = () => {

  return (
    <div className="row">
      <div className="col-12 col-md-12 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <p>Shore Cottage is on the lochside in the beautiful village of Arnisdale near Glenelg in the Scottish Highlands.  It is less than 30 minutes from 
              the Isle of Skye using the world famous turntable ferry from at Kylereah. To get here use the directions in the maps below or the 
              cottage postcode is IV40 8JL if using a satnav.
            </p>
            <p>If travelling from the south of Scotland there are three main options that all meet at Spean Bridge.  From Glasgow it is over the Erskine Bridge and on the A82.  This is a beautiful 
              drive along the shores of Loch Lomond, over Rannoch Moor, through Glen Coe, Fort William to Spean Bridge.
              From Edinburgh there are two main options.  One is to head to Stirling on the M9 before taking the A84 through Callendar and onwards to the A82 and the Glen
              Coe Route.  The other is to start with the new Queensferry Crossing and head north up the M90 and A9 to Dalwhinnie and then turn on the A86 past Loch Laggan
              to Spean Bridge.
            </p>
            <p>From Spean Bridge follow the A82 north to the A87 turn off at Invergarry.  Travel past Loch Cluanie through Glen Shiel then 
               take the turning at Shiel Bridge signposted Glenelg, Skye Ferry.
                Follow the single-track road all the way over Ratagan Pass, through
                Glenelg and on a further 9 miles to Arnisdale. It is approximately 19
                miles from the main road to the cottage and takes about 45 minutes. 
            </p>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour">
        <iframe className="street-maps-image" src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d554277.5248014189!2d-6.124883967091602!3d57.13455599204529!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sshore%20cottage%20arnisdale!5e0!3m2!1sen!2suk!4v1621774498779!5m2!1sen!2suk" allowFullScreen="" loading="lazy"></iframe>
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour">
        <iframe className="street-maps-image" src="https://www.google.com/maps/embed?pb=!4v1621769993260!6m8!1m7!1s5LhJ2GQ-GDhgDlMxyEAIig!2m2!1d57.13431607710635!2d-5.563740362884412!3f118.1768835744164!4f-6.897131932496393!5f0.7820865974627469" allowFullScreen="" loading="lazy"></iframe>
      </div>
    </div>
  );
}

export default Location;